import { render, staticRenderFns } from "./password-recovery-page.vue?vue&type=template&id=244ef48a&scoped=true"
import script from "./password-recovery-page.vue?vue&type=script&lang=js"
export * from "./password-recovery-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244ef48a",
  null
  
)

export default component.exports